import React, { useState } from 'react'

import { ReactComponent as InicioReceso } from "assets/icons/Marcaciones/Inicio rec.svg"
import { ReactComponent as FinReceso } from "assets/icons/Marcaciones/FIN rec.svg"

import { ReactComponent as InicioLabores } from "assets/icons/Marcaciones/Inicio LAB.svg"
import { ReactComponent as FinLabores } from "assets/icons/Marcaciones/FIN Lab.svg"

import { Button } from "reactstrap"

import "assets/scss/Marcaciones/GeneralMarcaciones.scss"
import ModalConfirmacion from '../../Varios/Modals/ModalConfirmacion'

import COMUNICADOMARCACION from "../../../assets/img/ComunicadoMarcacionTH.jpg"


export enum TipoJornadaBotonMarcacion {
    LABORAL = 1,
    ALMUERZO = 2
}

export enum TipoSituacionBotonMarcacion {
    ENTRADA = 1,
    SALIDA = 2
}

type PropsBotonMarcacion = {
    tipoJornada: TipoJornadaBotonMarcacion,
    tipoSituacion: TipoSituacionBotonMarcacion,
    disabled: boolean,
    onClickButton?: () => Promise<void>
    className?: string
}

export default function BotonMarcacionEntradaSalida(props: PropsBotonMarcacion) {

    const {
        tipoJornada,
        tipoSituacion,
        disabled,
        onClickButton,
        className
    } = props;

    const [showFirstConfirmation, setshowFirstConfirmation] = useState<boolean>(false)
    const [showSecondConfirmation, setshowSecondConfirmation] = useState<boolean>(false)
    // const [mostrarModalMarcacion, setmostrarModalMarcacion] = useState<boolean>(false)



    const classNameAdicional = disabled ? "disabled" : "";


    function CerrarDosModals (){
        setshowFirstConfirmation(false);
        setshowSecondConfirmation(false);
    }

    const contenidoModalConfirmacion = () => {



        const classNameAdicionalModal = "buttonMarcacionesModal";

        var additionalprops = {}

        if (onClickButton !== undefined && tipoSituacion === TipoSituacionBotonMarcacion.ENTRADA)  {
            additionalprops = {
                onClick: () => onClickButton()
            }
        }
        else if (onClickButton !== undefined && tipoSituacion === TipoSituacionBotonMarcacion.SALIDA && !showSecondConfirmation) {
            
            if(tipoJornada ===  TipoJornadaBotonMarcacion.LABORAL){
                additionalprops = {
                    onClick: () => setshowSecondConfirmation(true)
                }
            }
            else {
                additionalprops = {
                    onClick: () => onClickButton()
                }
            }
            
        }
        else if (onClickButton !== undefined && tipoSituacion === TipoSituacionBotonMarcacion.SALIDA && showSecondConfirmation) {
            additionalprops = {
                onClick: () => {
                    
                    onClickButton()
                }
            }
        }

        const botonesEntradas = (
            <div className="containerButtonModalConfirmarMarcacion">
                <Button className={"btnModalConfirmarMarcacion btnModalConfirmarMarcacionNO"} onClick={() => CerrarDosModals()}>
                    NO
                </Button>
                <Button className={"btnModalConfirmarMarcacion  btnModalConfirmarMarcacionSI"} {...additionalprops}>
                    SI
                </Button>
            </div>
        )

        if (tipoSituacion === TipoSituacionBotonMarcacion.ENTRADA) {
            if (tipoJornada === TipoJornadaBotonMarcacion.ALMUERZO) {
                return (
                    <React.Fragment>
                        <div className="text-center">
                            <InicioReceso
                                id={"btnRegistrarInicioReceso"}
                                className={"btnRegistrarInicioReceso" + " " + classNameAdicionalModal}
                                style={{ "fill": "none" }}
                            />
                        </div>

                        <div className='marcacionConfirmacionText'>
                            <p className='textPreguntaConfirmacionMarcacion'>{"¿Está seguro que desea INICIAR su RECESO?"}</p>
                        </div>

                        {botonesEntradas}
                    </React.Fragment>
                )
            }
            else {
                return (
                    <React.Fragment>
                        <div className="text-center">
                            <InicioLabores
                                id={"btnRegistrarInicioLabores"}
                                className={"btnRegistrarInicioLabores" + " " + classNameAdicionalModal}
                                style={{ "fill": "none" }}
                            />
                        </div>

                        <div className='marcacionConfirmacionText'>
                            <p className='textPreguntaConfirmacionMarcacion'>{"¿Está seguro que desea INICIAR sus LABORES?"}</p>

                        </div>

                        {botonesEntradas}
                    </React.Fragment>
                )
            }
        }
        else {
            if (tipoJornada === TipoJornadaBotonMarcacion.ALMUERZO) {
                var texto = "¿Está seguro que desea FINALIZAR su RECESO?"
                if(showSecondConfirmation){
                    texto = "¿Está 100% seguro que desea FINALIZAR su JORNADA DE RECESO?"
                }
                return (
                    <React.Fragment>
                        <div className="text-center">
                            <FinReceso
                                id={"btnRegistrarFinReceso"}
                                className={"btnRegistrarFinReceso" + " " + classNameAdicionalModal}
                                style={{ "fill": "none" }}
                            />
                        </div>

                        <div className='marcacionConfirmacionText'>
                            <p className='textPreguntaConfirmacionMarcacion'>{texto}</p>
                        </div>

                        {botonesEntradas}
                    </React.Fragment>
                )
            }
            else {
                var texto = "¿Está seguro que desea FINALIZAR sus LABORES?"
                if(showSecondConfirmation){
                    texto = "¿Está 100% seguro que desea FINALIZAR su JORNADA DE LABORES?"
                }
                return (
                    <React.Fragment>
                        <div className="text-center">
                            <FinLabores
                                id={"btnRegistrarFinLabores" }
                                className={"btnRegistrarFinLabores" + " " + classNameAdicionalModal }
                                style={{ "fill": "none" }}
                            />
                        </div>

                        <div className='marcacionConfirmacionText'>
                            <p className='textPreguntaConfirmacionMarcacion'>{texto}</p>
                        </div>

                        {botonesEntradas}
                    </React.Fragment>
                )
            }
        }





    }

    const BotonAMostrar = () => {
        var additionalprops: any = {};

        if (onClickButton !== undefined) {
            additionalprops = {
                onClick: () => setshowFirstConfirmation(true)
            }
        }


        if (tipoJornada === TipoJornadaBotonMarcacion.ALMUERZO) {

            if (tipoSituacion === TipoSituacionBotonMarcacion.ENTRADA) {
                return (
                    <>
                        <div className="containerBtnMarcacion" {...additionalprops}>
                            <InicioReceso
                                id={"btnRegistrarInicioReceso" + classNameAdicional}
                                className={"btnRegistrarInicioReceso" + " " + className}
                                style={{ "fill": "none" }}
                            />
                            <div id={"txtInicioRec" + classNameAdicional} className={"text-center"}>
                                {"RECESO"}
                            </div>
                        </div>

                    </>


                )
            }
            else {
                return (
                    <div className="containerBtnMarcacion" {...additionalprops}>
                        <FinReceso
                            id={"btnRegistrarFinReceso" + classNameAdicional}
                            className={"btnRegistrarFinReceso" + classNameAdicional + " " + className}
                            style={{ "fill": "none" }}
                        />
                        <div id={"txtFinRec" + classNameAdicional} className={"text-center"}>
                            {"RECESO"}
                        </div>
                    </div>
                )
            }
        }


        else {

            if (tipoSituacion === TipoSituacionBotonMarcacion.ENTRADA) {
                return (
                    <div className="containerBtnMarcacion" {...additionalprops} >
                        <InicioLabores
                            id={"btnRegistrarInicioLabores" + classNameAdicional}
                            className={"btnRegistrarInicioLabores" + classNameAdicional + " " + className}
                            style={{ "fill": "none" }}
                        />
                        <div id={"txtInicioLab" + classNameAdicional} className={"text-center"}>
                            {"LABORES"}
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div className="containerBtnMarcacion" {...additionalprops}>
                        <FinLabores
                            id={"btnRegistrarFinLabores" + classNameAdicional}
                            className={"btnRegistrarFinLabores" + classNameAdicional + " " + className}
                            style={{ "fill": "none" }}
                        />
                        <div id={"txtFinLabores" + classNameAdicional} className={"text-center"}>
                            {"LABORES"}
                        </div>
                    </div>
                )
            }
        }
    }

    // const contenidoModalImagen = (
    //     <div style={{textAlign:"center"}}>
    //          <img  src = {COMUNICADOMARCACION} alt ="comunicadoMarcacion"></img>
    //     </div>
       
    // )

    return (
        <React.Fragment>
            {BotonAMostrar()}
            <ModalConfirmacion
                show={showFirstConfirmation || showSecondConfirmation}
                size='xl'
                centered={true}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={true}
                mensajeConfirmacion=''
                nombreBotonAccion='D'
                onClose={() => CerrarDosModals()}
                contentModal={contenidoModalConfirmacion()}

            />
            {/* <ModalConfirmacion
                show={mostrarModalMarcacion}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={true}
                mensajeConfirmacion=''
                contentModal={contenidoModalImagen}
                size='xl'
                nombreBotonAccion='Entendido'
                onClose={() => {
                    setmostrarModalMarcacion(false)
                    
                }
                }
                onClick={() => {
                    setmostrarModalMarcacion(false)

                    

                }}
            /> */}
        </React.Fragment>
    )
}
